var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRdn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32666)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#2A2A2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.625 3.37837H10.1874C10.2426 3.36149 10.2707 3.41212 10.3067 3.44024C10.7367 3.84644 11.1225 4.29708 11.4576 4.78462C11.9336 5.46642 12.3073 6.21422 12.5668 7.00424C12.8379 7.83899 12.9662 8.72212 12.9324 9.59962H10.6065C10.6179 9.48299 10.6221 9.36576 10.6189 9.24862C10.5947 8.42118 10.3393 7.60949 9.93713 6.89062C9.50681 6.12055 8.90606 5.45624 8.22319 4.90443C7.47956 4.30312 6.64256 3.82837 5.77069 3.44474C5.72231 3.42224 5.67169 3.40424 5.625 3.37837ZM7.31362 7.4998C8.09398 8.91153 8.87304 10.324 9.65081 11.7371C9.83812 12.078 10.0277 12.4177 10.2133 12.7592C9.24525 13.3791 8.28 14.0046 7.3125 14.625V7.4998H7.31362Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRdn);
export default __webpack_public_path__ + "static/media/rdn.c796ed47d2c5a43d67e90f993cacad2f.svg";
export { ForwardRef as ReactComponent };